import { Chess } from 'chess.js';
import { 
    analyzeGame as analyzeGameWithStockfishAPI, 
    MoveAnalysis as StockfishMoveAnalysis,
    GameAnalysisResult,
    GameAnalysisSummary 
} from '../services/stockfishApi';

export interface MoveAnalysis {
    move: string;
    moveIndex?: number;
    moveUCI?: string;
    bestMove?: string;
    evaluation?: number; // in pawns (not centipawns)
    bestEvaluation?: number;
    comment?: string;
    isBestMove?: boolean;
    isMistake?: boolean;
    isBlunder?: boolean;
    isInaccuracy?: boolean;
    evalLoss?: number;
    explanation?: string; // Why it's a blunder/mistake
    analysis?: string; // Rich analysis text from API
    evaluationDescription?: string; // Position evaluation description
    error?: string;
}

export interface AnalysisResult {
    analyses: MoveAnalysis[];
    summary?: GameAnalysisSummary;
}

/**
 * Analyze a chess game using your Stockfish endpoint
 * Returns both analyses and summary
 */
export const analyzeGameWithStockfish = async (
    moves: string[],
    fen: string,
    depth: number = 15
): Promise<AnalysisResult> => {
    // Use your Stockfish API
    const result = await analyzeGameWithStockfishAPI(moves, fen, depth);
    
    // Convert to our MoveAnalysis format
    const analyses: MoveAnalysis[] = result.analyses.map((analysis): MoveAnalysis => ({
        move: analysis.move,
        moveIndex: analysis.moveIndex,
        moveUCI: analysis.moveUCI,
        bestMove: analysis.bestMove,
        evaluation: analysis.evaluation,
        bestEvaluation: analysis.bestEvaluation,
        comment: analysis.comment,
        isBestMove: analysis.isBestMove,
        isMistake: analysis.isMistake,
        isBlunder: analysis.isBlunder,
        isInaccuracy: analysis.isInaccuracy,
        evalLoss: analysis.evalLoss,
        explanation: analysis.explanation || analysis.analysis,
        analysis: analysis.analysis,
        evaluationDescription: analysis.evaluationDescription,
        error: analysis.error,
    }));

    return {
        analyses,
        summary: result.summary,
    };
};


